import I18n from 'src/common/services/I18n';

import Star from '~/src/common/components/Rating/Star';
import { getStarsShape } from '~/src/common/components/Rating/utils';
import dayjs from '~/src/common/services/Date';
import { round } from '~/src/common/utils/number';

import { PropsFromInputs } from '../../types';

import { Body, Container, Foot, Head, Rating, Text, Title } from './layout';

type Props = PropsFromInputs<typeof import('./inputs').default>;

export default ({ name, rating, title, text, date, source }: Props) => {
  const score = Math.max(0, Math.min(5, round(rating * 2) / 2));

  return (
    <Container>
      <Head>
        <Text $bolder>{name}</Text>
        <Rating>
          {getStarsShape(score).map(mode => (
            <Star key={mode} size={14} color="#00664F" mode={mode} />
          ))}
        </Rating>
      </Head>
      <Body>
        <Title>{title}</Title>
        <Text>{text}</Text>
      </Body>
      <Foot>
        <Text>
          {I18n.t('landing.testimonials.source')}
          {source}
        </Text>
        <Text>{dayjs(date).format('DD MMMM YYYY')}</Text>
      </Foot>
    </Container>
  );
};
